import type { WorldFeature } from '../types';
import { fabricFeature } from './fabricFeature';
import { lastageYardFeature } from './landmarks/lastageYardFeature';

export const FABRIC_FEATURES: readonly WorldFeature[] = [fabricFeature, lastageYardFeature];
